import React from 'react';

import { DeleteMemberIcon } from '#/assets/svgs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, Button } from '#/components/ui';

const DeleteTeamConfirmation = ({ open, onClose, onConfirm, isLoading = false }) => {
    const handleClose = () => {
        onClose(false);
    };
    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className='flex flex-col gap-8 p-6 max-w-[25rem] bg-white'>
                <DialogHeader className='flex flex-col gap-5'>
                    <DialogTitle>
                        <DeleteMemberIcon className='w-12 h-12' />
                    </DialogTitle>
                    <DialogDescription className='flex flex-col space-y-2'>
                        <span className='text-lg text-gray900 font-medium'>Delete Member</span>
                        <span className='text-sm font-normal text-gray500'>
                            Are you sure you want to delete this member?
                        </span>
                    </DialogDescription>
                </DialogHeader>
                <div className='flex justify-between gap-3 w-full'>
                    <Button variant='outline' className='w-1/2 bg-transparent text-gray700' onClick={handleClose}>
                        Discard
                    </Button>
                    <Button
                        variant='destructive'
                        className='bg-error500 text-white w-1/2'
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Removing...' : 'Confirm'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteTeamConfirmation };
